import React from "react";
import type { SpecificationBlock } from "@/types/product";
import { useLocalizedTexts, t } from "@/utils/translations";
import shared from "../ProductDetailContent.module.css";
import styles from "./SpecificationsSection.module.css";

export const SpecificationsSection: React.FC<{ block: SpecificationBlock }> = ({
  block,
}) => {
  const localizedTexts = useLocalizedTexts();
  const specs = block.specifications ?? [];
  if (!specs.length) return null;

  const half = Math.ceil(specs.length / 2);
  const left = specs.slice(0, half);
  const right = specs.slice(half);

  return (
    <section className={`${shared.section} ${shared.bgVeryDark}`}>
      <div className={shared.inner}>
        <div className={styles.card}>
          <h2 className={styles.heading}>
            {t(
              localizedTexts,
              "Tracker.Products.SpecificationsHeading",
              "Specifications"
            )}
          </h2>
          {block.subtitle && (
            <p className={styles.subtitle}>{block.subtitle}</p>
          )}
          <div className={styles.grid}>
            <div className={styles.column}>
              {left.map((spec) => (
                <div key={spec.key} className={styles.row}>
                  <span className={styles.key}>{spec.key}</span>
                  <span className={styles.value}>{spec.value}</span>
                </div>
              ))}
            </div>
            <div className={styles.column}>
              {right.map((spec) => (
                <div key={spec.key} className={styles.row}>
                  <span className={styles.key}>{spec.key}</span>
                  <span className={styles.value}>{spec.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecificationsSection;
